/**
 * Returns a patch object for meeting scopeNodeId updates.
 *
 * If draftScopeNodeId is unchanged compared to savedScopeNodeId (normalizing undefined to null),
 * returns an empty object {} so scopeNodeId is not sent over the wire.
 * Otherwise, returns { scopeNodeId: draftScopeNodeId ?? null } so the new value or null (clear) is sent.
 */
export function meetingScopeNodeIdPatch(
  draftScopeNodeId?: string | null,
  savedScopeNodeId?: string | null,
): { scopeNodeId?: string | null } {
  return (draftScopeNodeId ?? null) === (savedScopeNodeId ?? null)
    ? {}
    : { scopeNodeId: draftScopeNodeId ?? null }
}
